var offices = offices || 0;
(function ($, window) {
    "use strict";

    var officeLat = 0, // Head office default Latitude
        officeLng = 0, // Head office default Longtitude
        mapElement,
        isOfficePage = false,
        firstMarker;

    DSV.ui.maps = {
        googleMapsApiKey: "AIzaSyDlT-lKAabFfExqPoWMLuZ7sRG05t60ACY",
        staticMapApi: "AIzaSyDlT-lKAabFfExqPoWMLuZ7sRG05t60ACY",
        officeInfo: [],

        setupMap: function(){
            var map = new google.maps.Map(mapElement, {
                zoom: 8,
                center: new google.maps.LatLng(officeLat, officeLng),
                mapTypeId: 'terrain',
                scrollwheel: false,
                disableDefaultUI: true,
                zoomControl: true,
                maxZoom: 16,
                minZoom: 3,
                draggable: (DSV.tools.screenMode.currentMode >= 3) || false,
                styles: [
                    {
                        featureType: 'all',
                        stylers: [
                            { saturation: -80 }
                        ]
                    },{
                        featureType: 'road.arterial',
                        elementType: 'geometry',
                        stylers: [
                            { hue: '#b4b089' },
                            { saturation: 50 }
                        ]
                    },{
                        featureType: 'poi.business',
                        elementType: 'labels',
                        stylers: [
                            { visibility: 'off' }
                        ]
                    }
                ]
            });
            this.setMarkers(map);
        },
        
        createPrintableMap: function (map, lat, lng) {
            var $staticMap = $("#static-map"),
                mapString = "https://maps.googleapis.com/maps/api/staticmap";

            mapString += "?size=640x325";
            mapString += "&center=" + lat +"," + lng;
            mapString += "&zoom=11";
            mapString += "&markers=" + lat +"," + lng;
            mapString += "&key=" + this.staticMapApi;

            if($staticMap.length){
                $staticMap[0].src = mapString;
            }
        },
        setMarkers: function (map) {
            var selfScope = this;
            // Adds markers to the map.

            // Marker sizes are expressed as a Size of X,Y where the origin of the image
            // (0,0) is located in the top left of the image.
            var image = new google.maps.MarkerImage("https://dsv-media-premium.azureedge.net/frontend/base/static-new/dist/img/pin_map.png", null, null, null, new google.maps.Size(28,43));
            // Origins, anchor positions and coordinates of the marker increase in the X
            // direction to the right and in the Y direction down.

            var offsetX = parseInt($(mapElement).data('offset-x')) || -200;
            var offsetY = parseInt($(mapElement).data('offset-y')) || 0;

            if(!isOfficePage && offices){
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < offices.length; i++) {
                    var office = offices[i];
                    if(office[1] && office[2]) {
                        var marker = new google.maps.Marker({
                            position: {lat: office[1], lng: office[2]},
                            map: map,
                            flat: true,
                            icon: image,
                            title: office[0],
                            zIndex: office[3] || i+1
                        });
                    }

                    //extend the bounds to include each marker's position
                    bounds.extend(marker.position);
                    //now fit the map to the newly inclusive bounds

                    if (DSV.tools.screenMode.currentMode >= 2) {
                        var infoContent = '<div class="office-info">'
                            + '<h3>' + office[9] + '</h3>'
                            +'<p>' + office[0] + '<br />'
                            + office[4] + '<br />'
                            + office[5] + ' ' + office[6] + '<br />'
                            + office[7] + '</p>'
                            +'<div><a class="cta cta--link" href="'+ office[10]+'" data-office="'+ i +'" target="_blank" rel="noopener">'+ office[8] +'</a></div>'
                            +'</div>';
                        var infoWindow = new google.maps.InfoWindow({
                            content: infoContent
                        });
                        selfScope.officeInfo.push(infoWindow);

                        marker.addListener('click',function(e) {
                            selfScope.openOfficeInfo(this, this.zIndex -1);
                        });
                    }
                    if(DSV.tools.screenMode.currentMode >= 3){
                        if(i === 0){
                            firstMarker = marker;
                            $("#static-map").after(infoContent);
                        }
                    }
                }
                // Make the map fit all markers within bounds
                map.fitBounds(bounds);

                // Zoom and pan map according to custom set zoomlevel and offset values
                if(DSV.tools.screenMode.currentMode >= 3) {
                    var listener = google.maps.event.addListener(map, "idle", function () {
                        var customZoomLevel = parseInt($(mapElement).data('zoomlevel'));
                        if(customZoomLevel){
                            map.setZoom(customZoomLevel);
                        }
                        map.panBy(offsetX, offsetY);
                        setTimeout(function(){
                            selfScope.officeInfo[0].open(map, firstMarker);
                        }, 1500);
                        setTimeout(function() {
                            DSV.ui.maps.createPrintableMap(map, firstMarker.getPosition().lat(), firstMarker.getPosition().lng());
                        }, 2500);

                        google.maps.event.removeListener(listener);
                    });
                }
            } else {
                if(officeLat && officeLng) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(officeLat, officeLng),
                        map: map,
                        icon: image
                    });

                    $("#office-address").clone().attr("id", "#office-address-print").insertAfter("#static-map");

                    if(DSV.tools.screenMode.currentMode >= 2){
                        infoWindow = new google.maps.InfoWindow({
                            content: document.getElementById("office-address")
                        });

                        this.officeInfo = infoWindow;
                        setTimeout(function() {
                            infoWindow.open(map, marker);
                        }, 1000);
                        setTimeout(function() {
                            DSV.ui.maps.createPrintableMap(map, officeLat, officeLng);
                        }, 2500);

                        marker.addListener('click', function (e) {
                            selfScope.officeInfo[0] = infoWindow;
                            selfScope.openOfficeInfo(this, 0);
                        });
                    }
                    if(DSV.tools.screenMode.currentMode >= 3){
                        map.panBy(offsetX, offsetY);
                    }
                }
            }
        },

        openOfficeInfo: function (marker, i) {
            if(isOfficePage) {
                this.officeInfo[i].open(map, marker);
            } else {
                this.closeOfficeInfos();
                this.officeInfo[i].open(map, marker);
            }
        },

        closeOfficeInfos: function () {
            if(isOfficePage) {
                officeInfo.close();
            } else {
                for (var i = 0; i < this.officeInfo.length; i++) {
                    this.officeInfo[i].close();
                }
            }
        },

        init: function(){
            mapElement = document.getElementById('map');
            if(mapElement){
                // Insert GoogleMaps Api to load async
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src  = "https://maps.googleapis.com/maps/api/js?key="+ this.googleMapsApiKey +"&callback=DSV.ui.maps.setupMap";
                $("head").append(s);
            }
        }
    }; // DSV.ui.maps
})(jQuery, window);
